import script from "./LP.vue?vue&type=script&setup=true&lang=js"
export * from "./LP.vue?vue&type=script&setup=true&lang=js"

import "./LP.vue?vue&type=style&index=0&id=f5177e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5177e22"]])

export default __exports__